module.exports = __webpack_public_path__ + "static/media/back.0bde72a0.svg";